// src/pages/PrivacyPolicyPage.tsx
import { motion } from 'framer-motion';
import ReactMarkdown from 'react-markdown';
import PageHeader from '@/components/PageHeader';
// Import the markdown content directly
import privacyPolicyMarkdown from '@/data/privacy-policy.md?raw';

const PrivacyPolicyPage = () => {
  // Instead of fetching, we can use the imported markdown directly
  const content = privacyPolicyMarkdown;

  return (
    <div>
      {/* Use the PageHeader component */}
      <PageHeader
        title="Privacy Policy"
        description="Our commitment to protecting your privacy"
      />

      <div className="container mx-auto px-4">
        <motion.div
          className="max-w-full mx-auto bg-white rounded-lg shadow-sm py-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}>
          <div className="prose prose-lg max-w-none prose-headings:text-primary prose-a:text-secondary">
            <ReactMarkdown
              components={{
                // Custom component for paragraphs to style the "Last updated" text
                p: ({ children, ...props }) => {
                  const childText = children?.toString() || '';

                  // Check if this paragraph starts with "Last updated"
                  if (childText.startsWith('Last updated')) {
                    return (
                      <p {...props} className="text-sm text-gray-400 mb-12">
                        {children}
                      </p>
                    );
                  }

                  // Regular paragraph rendering
                  return <p {...props}>{children}</p>;
                },
              }}>
              {content}
            </ReactMarkdown>
          </div>
        </motion.div>
      </div>

      {/* CTA Section */}
      <div className="container mx-auto px-4 py-40">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}>
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Have questions about our privacy policy?
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            If you have any questions or concerns about our Privacy Policy,
            please don't hesitate to contact us.
          </p>
          <a
            href="/contact"
            className="bg-secondary hover:bg-secondary/90 text-white font-semibold py-3 px-8 rounded-full inline-block transition-colors">
            Contact Us
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
